module.exports = __webpack_public_path__ + "images/c8e83c294b00695ce5622a3dd6dbf6de.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/omasaastopankki.png
// module id = 1520
// module chunks = 1